<template>
  <div class="accueil">
    <!-- Affiche les visites principales -->
    <div class="test">
      <div class="logoSentiers"></div>
      <!-- 1ère visite -->
      <!-- <a :href="publicPath + 'visites/lama/index.html'"> -->
      <a href="#">
        <v-btn class="firstVisit"
          ><span class="visiteName">{{ $t("Scopamene") }}</span></v-btn
        >
      </a>
      <!-- 2nd visite -->
      <a :href="publicPath + 'visites/stelucietallano/index.html'">
      <!-- <a href="http://tests-sdp.arobase.corsica/stelucietallano/"> -->
        <v-btn class="secondVisit"
          ><span class="visiteName">{{ $t("Tallano") }}</span></v-btn
        >
      </a>
    </div>

    <!-- Bouton pour aller sur la page des autres visites -->
    <v-btn
      @click="
        $router.push({
          name: 'Sentiers',
        })
      "
      
      class="btnDisplay"
    >
      <!-- Découvrir d'autres sentiers -->
      <span class="texteBtn">{{ $t("sentiersButton") }}</span>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Accueil",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      publicPath: "publicPathState",
    }),
  },
  methods: {},
};
</script>

<style scoped>
.accueil {
  background-image: url("../assets/maquette/fonds/background.png");
  background-size: cover;
  height: 1080px;
  width: 1920px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.logoSentiers {
  background-image: url("../assets/maquette/logos/logoSentiers.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  top: 45px;
  left: 648px;
  width: 621px;
  height: 272px !important;
}

.firstVisit {
  background-image: url("../assets/maquette/sentiers/scopamena.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  bottom: 202px;
  left: 258px;
  width: 717px;
  height: 539px !important;
}

.secondVisit {
  background-image: url("../assets/maquette/sentiers/tallano.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  bottom: 202px;
  width: 717px;
  height: 539px !important;
}

.visiteName {
  display: block;
  position: absolute;
  top: 168px;
  left: 106px;
  color: white;
  font-size: 34pt;
  text-transform: none;
  font-family: "CenturyGothic";
}

.btnDisplay {
  background-image: url("../assets/maquette/buttons/button.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  bottom: 5vh;
  width: 1396px;
  height: 158px !important;
  font-family: "CenturyGothic";
}

.texteBtn {
  font-size: 60px;
  color: white;
  position: absolute;
  top: -44px;
  left: 453px;
  text-transform: none;
}

.text-nowrap {
  -webkit-line-clamp: unset !important;
}
</style>
